.biel-search-body-container {
  display: flex;
  flex-direction: column;
  max-height: var(--biel-search-body-max-height);
  overflow-y: auto;
  overflow-x: hidden;
}

.biel-search-body-container::-webkit-scrollbar {
  width: 6px;
}

.biel-search-body-container::-webkit-scrollbar-thumb {
  background-color: var(--biel-chat-scrollbar-color);
  border-radius: 10px;
  border: 3px solid transparent;
}

.biel-search-body-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--biel-chat-scrollbar-hover-color);
}

.biel-search-body__result-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.biel-search-body__result-item {
  margin: 0;
  padding: 0;
  display: flex;
}

.biel-search-body__result {
  width: 100%;
}

/* Todo: move to standalone component, reused between search and chat */
.loading-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-top: 10px;
}

.loading-animation .dot {
  width: 8px;
  height: 8px;
  margin: 0 5px;
  background-color: var(--biel-text-color);
  border-radius: 50%;
  animation: bounce 1.2s infinite ease-in-out;
}

.loading-animation .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-animation .dot:nth-child(2) {
  animation-delay: -0.16s;
}

.loading-animation .dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}